import {
  TIPO_IMPUESTO_EMPRESA_ENUM,
  TipoImpuestoEmpresaEnumType,
} from "api/Types/TipoImpuestoEmpresaEnum"
import { TFunction } from "i18next"

export const TaxType = ({
  type,
  t,
}: {
  type?: TipoImpuestoEmpresaEnumType
  t: TFunction
}) => {
  const typeOptions = {
    [TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA]: {
      label: t("Compras"),
      tailwind: "tw-bg-secondary-10 tw-text-secondary",
    },
    [TIPO_IMPUESTO_EMPRESA_ENUM.VENTA]: {
      label: t("Ventas"),
      tailwind: "tw-bg-info-10 tw-text-info",
    },
    [TIPO_IMPUESTO_EMPRESA_ENUM.OTRO]: {
      label: t("Otros"),
      tailwind: "tw-bg-neutral-10 tw-text-neutral-75",
    },
  }

  return (
    <div
      className={`tw-w-fit tw-py-1 tw-px-4 tw-rounded-md tw-text-sm tw-font-medium tw-text-center tw-mx-auto ${
        typeOptions?.[type ?? TIPO_IMPUESTO_EMPRESA_ENUM.OTRO]?.tailwind
      }`}
    >
      {typeOptions?.[type ?? TIPO_IMPUESTO_EMPRESA_ENUM.OTRO]?.label}
    </div>
  )
}
